<template>
    <button @click="share" class="share icon-btn" :class="props.classBtn">
        <IconDef name="share"/>
    </button>
</template>

<script setup>
import IconDef from "~/components/UI/IconDef.vue"

const props = defineProps({
    classBtn: {
        type: String,
        default: ''
    },
    text: {
        type: String,
        default: ""
    },
    title: {
        type: String,
        default: ""
    }
});

function share() {
    navigator.share({
        text: props.text,
        url: location.href,
        title: props.title,
    });
}
</script>
